<div fxLayout="column">
  <!-- IE requires all fxLayout="column" elements to have the child contents wrapped in a plain div tag -->
  <div *ngIf="isBrowserIE; else quickpaymentFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
    <ng-container *ngTemplateOutlet="quickpaymentFlexColumnTemplate"></ng-container>
  </div>
</div>

<ng-template #quickpaymentFlexColumnTemplate>
  <div fxFlex.lt-md="10px" fxFlex.gt-sm="25px">&nbsp;</div>
  <div fxFlex="100%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px">
    <div *ngIf="isBrowserIE && media.isActive('lt-md'); else quickpaymentMainFlexColumnTemplate">
      <ng-container *ngTemplateOutlet="quickpaymentMainFlexColumnTemplate"></ng-container>
    </div>
  </div>
  <div fxFlex.lt-md="10px" fxFlex.gt-sm="25px">&nbsp;</div>
</ng-template>

<ng-template #quickpaymentMainFlexColumnTemplate>
  <div fxFlex="5%" fxHide.lt-md></div>
  <div fxFlex="90%" fxFlex.lt-md="100%" ngStyle.lt-md="padding-left: 8px; padding-right: 8px">
    <div class="display-text normal-paragraph-spacing">
      <mat-card>
        <mat-card-content>
          <div fxLayout="column">
            <div *ngIf="isBrowserIE; else quickpaymentHeaderFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
              <ng-container *ngTemplateOutlet="quickpaymentHeaderFlexColumnTemplate"></ng-container>
            </div>
          </div>
          <div fxLayout="column">
            <div *ngIf="isBrowserIE; else quickpaymentStepperFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
              <ng-container *ngTemplateOutlet="quickpaymentStepperFlexColumnTemplate"></ng-container>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div fxFlex="5%" fxHide.lt-md></div>
</ng-template>

<ng-template #quickpaymentHeaderFlexColumnTemplate>
  <div fxLayout="column">
    <div class="display-text primary-dark-color-important" *ngIf="userFullName.length > 0">
      <span style="white-space: nowrap !important;" fxLayoutAlign="start center">
        <b>{{ userFullName }}</b>
      </span>
    </div>
    <div class="display-text primary-dark-color-important">
      <b
        ><span i18n="@@quick-pay-payment.header.participant-id.label">quick-pay-payment.header.participant-id.label</span>:&nbsp;{{
          participantIdString
        }}</b
      >
    </div>
    <div class="border-bottom-blue" style="margin-top: 16px"></div>
  </div>
</ng-template>

<ng-template #quickpaymentStepperFlexColumnTemplate>
  <mat-vertical-stepper [linear]="true" #quickPaypaymentStepper>
    <ng-template matStepperIcon="edit"> <mat-icon>done</mat-icon> </ng-template>
    <ng-template matStepperIcon="done"> <mat-icon>done</mat-icon> </ng-template>
    <mat-step [completed]="step1Complete" [editable]="step1Editable">
      <ng-template matStepLabel i18n="@@quick-pay-payment.stepper.step1.label">quick-pay-payment.stepper.step1.label</ng-template>
      <div class="display-text normal-paragraph-spacing center-" fxLayoutAlign="center center" *ngIf="showSpinner">
        <mat-spinner color="accent" diameter="32"></mat-spinner>
      </div>
      <div class="display-text primary-dark-color-important normal-paragraph-spacing" *ngIf="!showSpinner">
        <b><span i18n="@@quick-pay-payment.stepper.step1.title">quick-pay-payment.stepper.step1.title</span></b>
      </div>
      <app-quick-pay-payment-note-list
        [participantId]="participantId"
        [lastName]="lastName"
        [zipCode]="zipCode"
        [displayNotices]="true"
        (selected)="onQuickPayPaymentNoteListSelected($event)"
        *ngIf="!showSpinner"
      ></app-quick-pay-payment-note-list>
    </mat-step>
    <mat-step [completed]="step2Complete" [editable]="step2Editable">
      <ng-template matStepLabel i18n="@@quick-pay-payment.stepper.step2.label">quick-pay-payment.stepper.step2.label</ng-template>
      <div class="display-text primary-dark-color-important normal-paragraph-spacing">
        <b><span i18n="@@quick-pay-payment.stepper.step2.title">quick-pay-payment.stepper.step2.title</span></b>
      </div>
      <app-quick-pay-payment-amount
        [displayNotices]="true"
        [quickpaypaymentSelected]="quickpaypaymentSelected"
        (dataComplete)="onQuickPayPaymentAmountDataComplete($event)"
        (selected)="onQuickPayPaymentAmountSelected($event)"
      ></app-quick-pay-payment-amount>
    </mat-step>
    <mat-step [completed]="step3Complete" [editable]="step3Editable">
      <ng-template matStepLabel i18n="@@quick-pay-payment.stepper.step3.label">quick-pay-payment.stepper.step3.label</ng-template>
      <div class="display-text primary-dark-color-important normal-paragraph-spacing" *ngIf="!step3Complete">
        <b><span i18n="@@quick-pay-payment.stepper.step3.title">quick-pay-payment.stepper.step3.title</span></b>
      </div>
      <app-quick-pay-payment-form
        [participantId]="participantId"
        [paymentAmount]="paymentAmountValue"
        [quickpaypaymentSelected]="quickpaypaymentSelected"
        (dataComplete)="onQuickPayPaymentFormDataComplete($event)"
        (submitted)="onQuickPayPaymentSubmitted($event)"
        (canceled)="onQuickPayPaymentCanceled($event)"
      ></app-quick-pay-payment-form>
    </mat-step>
  </mat-vertical-stepper>
</ng-template>
